import { render, staticRenderFns } from "./lineDetail.vue?vue&type=template&id=94023536&scoped=true&"
import script from "./lineDetail.vue?vue&type=script&lang=js&"
export * from "./lineDetail.vue?vue&type=script&lang=js&"
import style0 from "./lineDetail.vue?vue&type=style&index=0&id=94023536&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "94023536",
  null
  
)

export default component.exports